var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[(_vm.state.loaded)?_c('Header',{attrs:{"header":"Home","title":"Klasifikasi Dokumen","state":_vm.state,"addLink":_vm.goToAddView,"forbidden":_vm.forbid}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }